console.debug("-------------- Localization Script -------------------------")
if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          overlay: this.querySelector('.country-selector__overlay'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        // If a trigger button/panel/overlay exist (old inline dropdown version),
        // wire up open/close keyboard behavior. For popup-based versions that
        // only use filtering and submission, this block will be skipped.
        if (this.elements.button && this.elements.panel && this.elements.overlay) {
          this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
          this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
          this.addEventListener('focusout', this.closeSelector.bind(this));
          this.elements.button.addEventListener('click', this.openSelector.bind(this));

          if (this.elements.closeButton) {
            this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
          }
          if (this.elements.overlay) {
            this.elements.overlay.addEventListener('click', this.hidePanel.bind(this));
          }
        }

        // Shared search/filter behaviour for both old inline and new popup usage
        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        // Use delegation in capture phase so reset runs before any other handler
        this.addEventListener('click', this.onLocalizationFormClick.bind(this), true);

        // Clicking any country link should set the code and submit the form
        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        this.elements.overlay.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.style.overflow = '';
        this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const code = event.currentTarget.dataset.value;
        if (!code) return;
        const form = this.querySelector('form');
        const input = this.elements.input || this.querySelector('input[name="country_code"]');
        if (!form || !input) return;
         const clickedLi = event.currentTarget.closest('li');
        if (clickedLi) {
          clickedLi.classList.add('loading');
        }
        input.value = code;
        form.submit();
      }

      onLocalizationFormClick(event) {
        const resetBtn =
          event.target.closest('.country-filter__reset-button') ||
          event.target.closest('[data-country-reset]');
        const searchIcon = event.target.closest('.country-filter__search-icon');
        const search = this.elements.search || this.querySelector('input[name="country_filter"]');
        const hasSearchValue = search && search.value.trim().length > 0;

        if (resetBtn || (searchIcon && hasSearchValue)) {
          event.preventDefault();
          event.stopPropagation();
          this.resetFilter(event);
        }
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.removeAttribute('hidden');
        this.elements.overlay.removeAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        document.body.style.overflow = 'hidden';
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          document.body.style.overflow = '';
          this.hidePanel();
        }
      }

      filterCountries() {
        if (!this.elements.search) return;

        const rawValue = this.elements.search.value || '';
        const searchValue = rawValue.toLowerCase().trim();
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = 0;

        const resetBtn =
          this.elements.resetButton || this.querySelector('[data-country-reset]') || this.querySelector('.country-filter__reset-button');
        if (resetBtn) {
          resetBtn.classList.toggle('hidden', !searchValue);
        }

        if (popularCountries) {
          // Hide popular countries group when searching
          popularCountries.classList.toggle('hidden', Boolean(searchValue));
        }

        allCountries.forEach((item) => {
          const li = item.parentElement;
          if (!li) return;

          const nameEl = item.querySelector('.country');
          const currencyEl = item.querySelector('.localization-form__currency');

          const countryName = (nameEl?.textContent || '').toLowerCase();
          const isoCode = (item.dataset.value || '').toLowerCase();
          const currencyText = (currencyEl?.textContent || '').toLowerCase();

          const matches =
            !searchValue ||
            countryName.includes(searchValue) ||
            isoCode.includes(searchValue) ||
            currencyText.includes(searchValue);

          if (matches) {
            li.classList.remove('hidden');
            visibleCountries++;
          } else {
            li.classList.add('hidden');
          }
        });

        if (this.elements.liveRegion && window.accessibilityStrings?.countrySelectorSearchCount) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        const selectorWrapper = this.querySelector('.country-selector');
        const selectorList = this.querySelector('.country-selector__list');
        if (selectorWrapper) selectorWrapper.scrollTop = 0;
        if (selectorList) selectorList.scrollTop = 0;
      }

      resetFilter(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        const search = this.elements.search || this.querySelector('input[name="country_filter"]');
        if (!search) return;
        search.value = '';
        this.filterCountries();
        search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}
